import { render, staticRenderFns } from "./BAnnouncement.vue?vue&type=template&id=38a2af48"
import script from "./BAnnouncement.vue?vue&type=script&lang=js"
export * from "./BAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports